const messages = {
    recurringPayment: 'Pago recurrente',
    recurringPaymentDescription:
        'Configure una cadencia de pago recurrente para este proveedor. Ambos campos deben establecerse juntos o dejarse vacíos.',
    paymentFrequency: 'Frecuencia de pago',
    defaultPaymentAmount: 'Monto de pago predeterminado',
    paymentFrequencyNone: 'Ninguna / Manual',
    paymentFrequencyWeekly: 'Semanal',
    paymentFrequencyBiWeekly: 'Quincenal',
    paymentFrequencyMonthly: 'Mensual',
    recurringPaymentBothRequired:
        'La frecuencia y el monto predeterminado deben establecerse juntos o ambos quedar vacíos.',
    recurringPaymentAmountGreaterThanZero:
        'El monto predeterminado debe ser mayor que cero cuando está establecido.',
    openDraftCollisionTitle: 'Ya existe un período de pago abierto',
    openDraftCollisionDescription:
        'Ya hay un período de pago abierto para {payDate}. Continúe con el período existente o cancele para elegir otra acción.',
    openDraft: 'Abrir borrador',
    goToReview: 'Ir a revisión',
    draftCount: 'Borrador',
    reviewCount: 'Revisión',
    printedCount: 'Impreso',
    // Invoices tab
    uploadInvoice: 'Subir factura',
    noInvoices: 'Sin facturas aún',
    invoiceDeletedSuccessfully: 'Factura eliminada correctamente',
    errorLoadingInvoices: 'Error al cargar las facturas',
    youWantToRemoveInvoice: 'Eliminar factura',
    invoiceDelete:
        '¿Está seguro de que desea eliminar esta factura? Esta acción no se puede deshacer.',
    errorDownloadingInvoice: 'Error al descargar la factura',
    fileName: 'Nombre del archivo',
    invoiceDate: 'Fecha de factura',
    uploadedOn: 'Subido el',
    unauthorizedViewInvoices: 'No tiene autorización para ver las facturas',
    unauthorizedViewPayments: 'No tiene autorización para ver los pagos',
    // External providers list
    errorLoadingProviders: 'Error al cargar los proveedores',
};

export default messages;
